import i18n from '~/locales/i18n';

i18n.addResourceBundle('ar', 'app', {
  basicInfo: 'المعلومات الأساسية',
  listingDescription: 'وصف العقار',
  listingDetails: 'تفاصيل العقار والمزايا',
  photosVideos: 'الفيديوهات والصور',
  publish: 'النشر',
  confirmPhoneNumberMessage:
    'لإضافة اعلانك ، نحتاج الي تأكيد رقم هاتفك من خلال الدخول إلى',
  mySettings: 'إعدادتي',
  follow: 'متابعة',
  optional: 'اختيارى',
  referenceNumber: 'الرقم المرجعى',
  enterReferenceNumberText: 'اكتب الرقم المرجعى',
  chooseSection: 'اختر القسم',
  propertyType: 'نوع العقار',
  choosePropertyType: 'اختر نوع العقار',
  location: 'الموقع',
  requiredPropertyType: 'اختر نوع العقار',
  locationOfPropertyOnMap: 'موقع العقار على الخريطة',
  requiredMap: 'اختر الموقع علي الخريطة',
  noResults: 'لا يوجد نتائج',
  missingPropertyLocation: 'لا يمكنك العثور على موقع عقارك ؟',
  newLocationRequest: 'طلب إضافة موقع جديد',
  regionRestrictionMessage: 'باقتك لا تدعم اضافة اعلان في هذه المنطقة',
  requiredLocation: 'اختر الموقع',
  chooseLocation: 'اختر الموقع',
  arabic: 'عربي',
  english: 'انجليزي',
  listingName: 'اسم الاعلان',
  listingNamePlaceholder: 'مثال: شقة للبيع فى مون ريزيدنس - المراسم ...',
  listingNameLabel: 'يظهر هذا الاسم كعنوان رئيسي علي اعلانك لدينا',
  listingDetailsPlaceholder: 'تفاصيل العقار',
  listingAddress: 'عنوان العقار',
  listingAddressPlaceholder: 'مثال: 21 دكتور نجيب محفوظ مدينة نصر ... ',
  listingTitleError: 'برجاء ادخال اسم الاعلان',
  listingDescriptionError: 'برجاء ادخال وصف العقار',
  listingAddressError: 'برجاء ادخال عنوان العقار',
  listingTitleMaxLength: 'هذه القيمة طويلة جدا. يجب ان تكون 100 حرف او اقل.',
  listingAddressMaxLength: 'يجب ان يكون عنوان العقار اقل من 100 حرف',
  descriptionAlert1:
    'قم بوصف العقار باللغتين العربية والإنجليزية لجذب المزيد من المشترين',
  descriptionAlert2: 'اضف اسم جيد لاعلانك لتشجع المشتريين على مشاهدة اعلانك',
  tipsForListing: 'نصائح لاعلان افضل',
  detailsOfListing: 'تفاصيل العقار',
  addListingPageTitle: 'أعلن عن عقارك •  | عقارماب',
  videosAndPhotos: 'الفيديوهات والصور',
  propertyPhotos: 'صور العقار',
  selectAll: 'تحديد الكل',
  delete: 'حذف',
  addPhotosHere: 'اضف الصور هنا',
  dragPhotosHere: 'اسحب الصور هنا',
  maxFileSize: 'أكبر حجم: 30 ميجا بايت',
  videoLink: 'رابط الفيديو',
  youtubeLink: 'اضف رابط الفيديو يوتيوب',
  mainPhoto: 'الصورة الرئيسية',
  mediaAlert1:
    'تحصل الإعلانات التى بها اكثر من 3 صور على تفاعل أكبر بقيمة 5 أضعاف',
  mediaAlert2: 'استخدم صور حقيقة للعقار',
  publishListing: 'نشر الاعلان',
  meter: 'متر²',
  bathroom: 'حمام',
  rooms: 'غرف',
  publishNow: 'نشر الان',
  payNow: 'ادفع الان',
  payAndPublishListing: 'ادفع وانشر اعلانك',
  listingCost: 'تكلفة الاعلان',
  listingPriceForLocation: 'سعر الاعلان لهذا الموقع',
  area: 'المساحة',
  byMeter: 'بالمتر',
  areaPlaceholder: 'اكتب المساحة',
  bathesNumber: 'عدد الحمامات',
  bathesNumberPlaceholder: 'اكتب عدد الحمامات',
  floor: 'الدور',
  floorPlaceholder: 'اكتب الدور',
  roomsNumber: 'عدد الغرف',
  roomsNumberPlaceholder: 'اكتب عدد الغرف',
  propertyTypeMarket: 'نوع العقار فى السوق',
  view: 'الاطلاله',
  finishType: 'نوع التشطيب',
  listingPrice: 'سعر العقار',
  price: 'السعر',
  paymentMethod: 'طريقة الدفع',
  egyptianPound: 'جنيه مصري',
  pricePerMeter: 'سعر المتر',
  pricePerMeterUnit: 'ج/متر²',
  buildYearOrDeliveryYear: 'سنة البناء أو التسليم',
  buildYearOrDeliveryYearPlaceholder: 'اختر سنة البناء أو التسليم',
  in: 'في',
  floors: 'عدد الادوار',
  floorsPlaceholder: 'اكتب عدد الادوار',
  apartments: 'شقق',
  apartmentsPlaceholder: 'اكتب عدد الشقق',
  landArea: 'مساحة الارض',
  landAreaPlaceholder: 'اكتب مساحة الارض',
  propertyRegistrationStatus: 'حالة التسجيل فى الشهر العقارى',
  propertyIsMortgageApproved: 'عقارك قابل للتمويل العقاري؟',
  others: 'أخرى',
  areaRequired: 'برجاء ادخال المساحة',
  priceRequired: 'برجاء ادخال السعر',
  propertyViewRequired: 'برجاء اختيار الاطلالة',
  propertyTypeMarketRequired: 'برجاء اختيار نوع العقار فى السوق',
  bathesNumberError: 'برجاء ادخال عدد الحمامات',
  floorError: 'برجاء ادخال الدور',
  roomsNumberError: 'برجاء ادخال عدد الغرف',
  buildYearError: 'برجاء ادخال سنة البناء أو التسليم',
  floorsError: 'برجاء ادخال عدد الادوار',
  apartmentsError: 'برجاء ادخال عدد الشقق',
  landAreaError: 'برجاء ادخال مساحة الارض',
  propertyRegistrationStatusError: 'برجاء اختيار حالة التسجيل فى الشهر العقارى',
  buyPackageLabel: 'ليس لديك رصيد كافي لنشر هذا الاعلان',
  buyPackageDesc: 'يمكنك شراء احدي الباقات المتاحة لدينا لنشر اعلانك.',
  paymentMethodRequired: 'برجاء اختيار طريقة الدفع',
  point: 'نقطة',
  requiredPhotos: 'برجاء ادخال عدد ({{count}}) صور على الأقل',
  sizeMoreThan2MG: 'الحجم اكبر من 30 ميجا',
  finishTypeRequired: 'برجاء اختيار نوع التشطيب',
  buyPackage: 'شراء باقة',
  errorPhotosSize:
    'لصورة "{{fileName}}" حجمها أكبر من {{fileSize}} ميجا ولا يمكن رفعها.',
  videoInvalidError: 'رابط الفيديو غير صالح. يجب أن يكون رابط يوتيوب صحيح.',
  autoGenerate: 'انشئ تلقائي',
  autoGenerated: 'تم الانشاء',
  listingAmenities: 'مزايا العقار',
  BALCONY: 'شرفة',
  SECURITY: 'أمن',
  ELEVATOR: 'أسانسير',
  ELECTRICITY_METER: 'عداد كهرباء',
  WATER_METER: 'عداد مياه',
  NATURAL_GAS_METER: 'عداد غاز طبيعي',
  LANDLINE_PHONE: 'هاتف أرضي',
  PETS_ALLOWED: 'مسموح بالحيوانات الأليفة',
  COVERED_PARKING: 'جراج مغطى',
  SWIMMING_POOL: 'حمام سباحة',
  PRIVATE_GARDEN: 'حديقة خاصة',
  MAID_ROOM: 'غرفة خدم',
  AIR_CONDITIONING: 'تكييف',
  KITCHEN_APPLIANCES: 'أجهزة مطبخ',
  KIDS_PLAY_AREA: 'منطقة ألعاب للأطفال',
  totalInstallmentPrice: 'سعر التقسيط الكلي',
  detailsSummaryTitle: 'ملخص التفاصيل',
  reviewYourDataBeforeContinue: 'راجع بياناتك قبل المتابعة',
  salePrice: 'سعر البيع',
  totalInstallmentPricePlaceholder: 'ادخل سعر العقار بالتقسيط',
  totalInstallmentPriceRequired: 'برجاء ادخال سعر التقسيط الكلي',
  downPaymentPrice: 'المقدم',
  isThereDownPayment: 'يوجد مقدم؟',
  downPaymentPricePlaceholder: 'ادخل سعر المقدم',
  downPaymentPercentagePlaceholder: 'ادخل نسبة المقدم',
  downPaymentRequired: 'برجاء ادخال سعر المقدم',
  paidAmountRequired: 'برجاء ادخال المبلغ المدفوع',
  installmentPeriod: 'مدة التقسيط',
  inMonths: 'بالشهور',
  months: 'شهور',
  installmentPeriodPlaceholder: 'أقصى مدة للتقسيط',
  monthlyInstallment: 'القسط الشهري',
  listingPercentage: 'نسبة المقدم',
  fromListingPrice: 'من سعر العقار',
  cashPrice: 'السعر نقداً',
  cashPricePlaceholder: 'ادخل سعر العقار نقداً',
  rentalDuration: 'مدة الإيجار',
  daily: 'يومي',
  weekly: 'أسبوعي',
  monthly: 'شهري',
  rentDailyInputPlaceholder: 'أدخل سعر الإيجار اليومي',
  rentWeeklyInputPlaceholder: 'أدخل سعر الإيجار الأسبوعي',
  rentMonthlyInputPlaceholder: 'أدخل سعر الإيجار الشهري',
  installmentsYearsRequired: 'برجاء تحديد مدة التقسيط',
  remainingInstallmentPeriodRequired: 'برجاء ادخال مدة التقسيط المتبقية',
  dailyPriceRequired: 'برجاء ادخال سعر الإيجار اليومي',
  weeklyPriceRequired: 'برجاء ادخال سعر الإيجار الأسبوعي',
  monthlyPriceRequired: 'برجاء ادخال سعر الإيجار الشهري',
  downPaymentPercentageRequired: 'برجاء ادخال نسبة المقدم',
  abbreviationEgyptianPound: ' ج.م',
  day: 'يوم',
  month: 'شهر',
  week: 'أسبوع',
  year: 'سنة',
  years: 'سنوات',
  downPaymentMustBeLessThanTotalInstallmentPrice:
    'يجب أن يكون المقدم أقل من سعر التقسيط الكلي',
  downPaymentMustBeAtLeastOnePercent: 'الحد الأدنى للمقدم 1% من السعر.',
  totalInstallmentPriceMustBeLargeThanPrice:
    'يجب أن يكون سعر التقسيط الكلي أكبر من سعر العقار',
  durationMustBeLessThan30Years: 'يرجى إدخال مدة تقسيط صحيحة',
  contractPriceRequired: 'برجاء ادخال سعر العقد',
  contractPrice: 'سعر العقد',
  contractPriceTooltip:
    'سعر الوحدة المتفق عليه في العقد مع المطور، قبل إضافة الأوفر برايس أو أي مبالغ أخرى',
  overPrice: 'الزيادة المطلوبة - Over Price',
  securityDeposit: 'وديعة الصيانة',
  paidAmount: 'المبلغ المدفوع',
  totalRequiredDownPaymentFromBuyer: 'إجمالي المقدم المطلوب من المشتري',
  totalRequiredDownPaymentTooltip:
    'إجمالي المبلغ الذي يجب دفعه للمالك الحالي عند إتمام عملية الشراء، ويشمل إجمالي المبالغ المدفوعة سابقًا بالإضافة إلى الأوفر برايس (إن وجدت).',
  totalPaidAmounts: 'إجمالي المبالغ المدفوعة',
  totalPaidAmountsTooltip:
    'إجمالي المبالغ التي تم سدادها للمطور حتى الآن، وتشمل مقدم الحجز وجميع الأقساط المدفوعة، ولا تشمل الأوفر برايس أو وديعة الصيانة.',
  totalPropertyPrice: 'السعر الكلي للعقار',
  remainingAmount: 'المبلغ المتبقي',
  LUX: 'لوكس',
  SUPER_LUX: 'سوبر لوكس',
  EXTRA_SUPER_LUX: 'اكسترا سوبر لوكس',
  SEMI_FINISHED: 'نصف تشطيب',
  WITHOUT_FINISH: 'بدون تشطيب',
  errorOccurred: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  remainingInstallmentDuration: 'مدة التقسيط المتبقية',
  marketListingTypeTitle: 'اختر نوع الإعلان',
  marketListingTypeDescription:
    'هل هذا الإعلان إعادة بيع أم وحدة أساسية داخل الكمبوند؟',
  resale: 'من مالك العقار (ريسيل)',
  primary: 'من المطور (أول سكن)',
  cloneUnitsModalDescription:
    'استخدام معلومات الكومباوند التي لدينا للحصول على تجربة افضل و  أسرع',
  clone: 'نسخ',
  skip: 'تخطي',
  seeMore: 'عرض المزيد',
  seeLess: 'عرض أقل',
  choseUnit: 'اختر مواصفات وحدتك',
  publishAccountTitle: 'لمن تنشر الإعلان؟',
  mainAccount: 'الحساب الرئيسي',
  mainAccountPublishDesc:
    'يُخصم من نقاط الحساب الرئيسي، ويُنشر الإعلان باسمه وأنت ناشره.',
  myAccountPublishDesc: 'يُخصم من نقاطك، ويُنشر الإعلان باسمك.',
  insufficientBalance: 'رصيدك غير كافي',
  subscribeToPackage: 'اشحن رصيدك',
  publishAccountPayNow: 'ادفع الآن',
  publishAccountPayNowCredits: 'ادفع الآن ({{credits}} نقاط)',
  mainAccountConfirmCredits: 'سيتم خصم النقاط من الحساب الرئيسي.',
  mainAccountConfirmDesc: 'سيُنشر الإعلان باسم الحساب الرئيسي وأنت ناشره.',
  dontShowAgainThisSession: 'لا تُظهر هذه الرسالة مرة أخرى',
});
